import React from 'react'
import fileDownload from 'js-file-download'
import { message } from 'antd'
import { formsThunks } from '@/entity/forms'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

export const DownloadLink = ({id}) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const handleDownloadFile = (e) => {
		e.preventDefault()

		let body = {
			data: id,
			onSuccess: (res) => {
				fileDownload(res, `${id}.xlsx`)
			},
			onError: (error) => {
				message.error(t('error'))
			},
		}

		dispatch(formsThunks.getDownloadById(body))
	}

	return <a style={{ color: '#17b67c' }} onClick={(e) => handleDownloadFile(e)}>{t('labor_records.download')}</a>
}